import { render, staticRenderFns } from "./extension-record-search.vue?vue&type=template&id=011e5da8"
import script from "./extension-record-search.vue?vue&type=script&lang=js"
export * from "./extension-record-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports